export default {
    state: {
        targetAddressInfo: null
    },
    actions: {},
    mutations: {
        AMAP_SEARCH_ADDRESS_SELECTED: function (state, val) {
            state.targetAddressInfo = val;
        }
    },
    getters: {}
};
